import React from 'react';
import PropTypes from 'prop-types';
import styles from '../DashboardPage/DashboardPage.module.scss';
import { LiveDataGrid } from '../../components/LiveDataGrid';
import { ECN_TRADE_SYMBOL_SUMMARY, ECN_TRADE_MMID_SUMMARY,
  ECN_ORDER_SYMBOL_SUMMARY, ECN_ORDER_MMID_SUMMARY, ECN_OPEN_ORDER_SYMBOL_SUMMARY, ECN_OPEN_ORDER_MMID_SUMMARY,
  ECN_UNENTITLED_SYMBOLS_SUMMARY, ECN_ORDER_TRADE_RATIO_SUMMARY
} from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();
const ECN_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_TRADE_SYMBOL_SUMMARY);
const ECN_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_TRADE_MMID_SUMMARY);

const ECN_ORDER_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_ORDER_SYMBOL_SUMMARY);
const ECN_ORDER_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_ORDER_MMID_SUMMARY);
const ECN_UNENTITLED_SYMBOLS_CONFIG = DASHBOARD_CONFIG.get(ECN_UNENTITLED_SYMBOLS_SUMMARY);
const ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_ORDER_TRADE_RATIO_SUMMARY);

const ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_OPEN_ORDER_SYMBOL_SUMMARY);
const ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_OPEN_ORDER_MMID_SUMMARY);

class DashboardEcnGrids extends React.PureComponent {
  render () {
    const pauseRealTimeData = this.props.pauseRealTimeData;
    return (
      <div className={styles.ecnTables} >

        <LiveDataGrid
          identifier={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.header}
          ws={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.ws}
          api={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

        <LiveDataGrid
          identifier={ECN_TRADE_MMID_SUMMARY_CONFIG.identifier}
          header={ECN_TRADE_MMID_SUMMARY_CONFIG.header}
          ws={ECN_TRADE_MMID_SUMMARY_CONFIG.ws}
          api={ECN_TRADE_MMID_SUMMARY_CONFIG.api}
          downloadApi={ECN_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_TRADE_MMID_SUMMARY_CONFIG.totalField}
          columns={ECN_TRADE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

        <LiveDataGrid
          identifier={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.header}
          ws={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.ws}
          api={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={ECN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          header={ECN_ORDER_MMID_SUMMARY_CONFIG.header}
          ws={ECN_ORDER_MMID_SUMMARY_CONFIG.ws}
          api={ECN_ORDER_MMID_SUMMARY_CONFIG.api}
          downloadApi={ECN_ORDER_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_ORDER_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_ORDER_MMID_SUMMARY_CONFIG.totalField}
          columns={ECN_ORDER_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.header}
          ws={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.ws}
          api={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          header={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.header}
          ws={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.ws}
          api={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.api}
          downloadApi={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.totalField}
          columns={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          header={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.header}
          ws={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.ws}
          api={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.api}
          downloadApi={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          columns={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={ECN_UNENTITLED_SYMBOLS_CONFIG.identifier}
          header={ECN_UNENTITLED_SYMBOLS_CONFIG.header}
          ws={ECN_UNENTITLED_SYMBOLS_CONFIG.ws}
          api={ECN_UNENTITLED_SYMBOLS_CONFIG.api}
          downloadApi={ECN_UNENTITLED_SYMBOLS_CONFIG.downloadApi}
          lastUpdatedField={ECN_UNENTITLED_SYMBOLS_CONFIG.lastUpdatedField}
          totalField={ECN_UNENTITLED_SYMBOLS_CONFIG.totalField}
          columns={ECN_UNENTITLED_SYMBOLS_CONFIG.columns}
          summaryGroupTitleColumn={ECN_UNENTITLED_SYMBOLS_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_UNENTITLED_SYMBOLS_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

      </div>
    );
  }
}

export default DashboardEcnGrids;
export const MemoizedDashboardEcnGrids = React.memo(DashboardEcnGrids);

DashboardEcnGrids.propTypes = {
  pauseRealTimeData: PropTypes.bool
};
